/**
 * Находит элемент с самой поздней датой из массива.
 * При равных датах выбирает элемент с большим ID.
 * 
 * @param items - Массив элементов с полями date и id
 * @returns Элемент с самой поздней датой/ID или undefined если массив пустой
 */
export function getLatestByDateAndId<T extends { date: string; id?: number | null }>(
	items: T[] | undefined
): T | undefined {
	if (!items || items.length === 0) {
		return undefined;
	}

	return items.reduce((latest, current) => {
		if (!latest) return current;
		
		const latestDate = new Date(latest.date);
		const currentDate = new Date(current.date);

		if (currentDate > latestDate) {
			return current;
		} else if (currentDate.getTime() === latestDate.getTime()) {
			// При равных датах выбираем с большим ID (более поздняя запись)
			const currentId = current.id ?? 0;
			const latestId = latest.id ?? 0;
			return currentId > latestId ? current : latest;
		}
		return latest;
	});
}
